import { useEffect } from 'react';
import { PoseLandmarker, FilesetResolver } from '@mediapipe/tasks-vision';
import toast from 'react-hot-toast';

function PoseLandmarkerInitializer({ setIsModelLoading, setError, poseLandmarkerRef, setIsPoseLandmarksReady }) {
  useEffect(() => {
    let isMounted = true;

    async function initializePoseLandmarker() {
      try {
        setIsModelLoading(true);
        const vision = await FilesetResolver.forVisionTasks('https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.8/wasm');
        const poseLandmarker = await PoseLandmarker.createFromOptions(vision, {
          baseOptions: {
            modelAssetPath:
              'https://storage.googleapis.com/mediapipe-models/pose_landmarker/pose_landmarker_heavy/float16/1/pose_landmarker_heavy.task',
            delegate: 'GPU'
          },
          runningMode: 'VIDEO',
          numPoses: 1
        });
        
        if (isMounted) {
          poseLandmarkerRef.current = poseLandmarker;
          setIsPoseLandmarksReady(true);
          console.log('PoseLandmarker initialized successfully');
        }
      } catch (err) {
        if (isMounted) {
          const errorMsg = `Failed to initialize pose detection: ${err.message}`;
          setError(errorMsg);
          toast.error(errorMsg);
        }
      } finally {
        if (isMounted) {
          setIsModelLoading(false);
        }
      }
    }

    initializePoseLandmarker();

    return () => {
      isMounted = false;
      if (poseLandmarkerRef.current) {
        poseLandmarkerRef.current.close();
        poseLandmarkerRef.current = null;
      }
    };
  }, [poseLandmarkerRef, setIsModelLoading, setError, setIsPoseLandmarksReady]);

  return null;
}

export default PoseLandmarkerInitializer;
